import React, { FC, ReactNode } from 'react';

import classNames from 'classnames';

import styles from './headline.module.scss';

import { SizeFormat } from 'types';

interface HeadlineProps {
  children: ReactNode;
  color?: string;
  className?: string;
  marginBottom?: SizeFormat;
  inline?: boolean;
  isDisable?: boolean;
}

const Headline1: FC<HeadlineProps> = props => {
  const { marginBottom, color, inline, children, className = '', ...restProps } = props;

  const headline1ClassNames = classNames(styles.headline1, className, {
    [styles.inline]: inline,
  });

  const stylesObj = {
    marginBottom,
    color,
  };

  return (
    <h1 style={stylesObj} className={headline1ClassNames} {...restProps}>
      {children}
    </h1>
  );
};

const Headline2: FC<HeadlineProps> = props => {
  const { color, marginBottom, inline, children, className = '', ...restProps } = props;
  const headline2ClassNames = classNames(styles.headline2, className, {
    [styles.inline]: inline,
  });
  const stylesObj = {
    color,
    marginBottom,
  };

  return (
    <h2 style={stylesObj} className={headline2ClassNames} {...restProps}>
      {children}
    </h2>
  );
};

const Headline3: FC<HeadlineProps> = props => {
  const { color, marginBottom, inline, children, className = '', ...restProps } = props;
  const headline3ClassNames = classNames(styles.headline3, className, {
    [styles.inline]: inline,
  });
  const stylesObj = {
    color,
    marginBottom,
  };

  return (
    <h3 style={stylesObj} className={headline3ClassNames} {...restProps}>
      {children}
    </h3>
  );
};

const Headline4: FC<HeadlineProps> = React.memo(props => {
  const {
    color,
    marginBottom,
    children,
    inline,
    className = '',
    isDisable,
    ...restProps
  } = props;

  const headline4ClassNames = classNames(styles.headline4, className, {
    [styles.inline]: inline,
    [styles.disabled]: isDisable,
  });

  const stylesObj = {
    color,
    marginBottom,
  };

  return (
    <h4 className={headline4ClassNames} style={stylesObj} {...restProps}>
      {children}
    </h4>
  );
});

export { Headline1, Headline2, Headline3, Headline4 };
